import $ from 'jquery';
import './index.scss';
import Sloth from '../Sloth';


@Sloth.component({
    defaultOptions : {}
})

export default class Modal {
    onInit() {
        const dom = this.dom;
        const self = this;
        if($('.Modal-wrapper', dom).length === 0) $('<div class="Modal-wrapper"><h1 class="Modal-title"></h1><div class="Modal-body"></div></div>').appendTo(dom);
        $('<button class=\'Modal-close\'></button>').appendTo('.Modal-wrapper', dom);

        $(dom).on('click', '.Modal-close', () => {
            self.hide();
        });

        // 点遮罩关闭
        $(dom).on('click', (evt) => {
            if(!$(evt.target).is('.Modal')) return;
            this.hide();
        });
    }

    setTitle(title) {
        $('.Modal-title', this.dom).text(title);
    }

    setBody(body) {
        // eslint-disable-next-line no-console
        console.log(this.dom);
        $('.Modal-body', this.dom).html(body);
    }

    show(options) {
        const { title, body } = options || {};
        if (title) this.setTitle(title);
        if (body) this.setBody(body);

        $(this.dom).show();
    }

    hide() {
        $(this.dom).hide();
        $(".Modal-body", this.dom).html("");
    }
}



/** WEBPACK FOOTER **
 ** ./components/Modal/index.js
 **/